import React from 'react';
import {SectionHeader} from "./SectionHeader";

export const SkillsComponent = () => {
    return (
        <div className='about-me-screen'>
            <SectionHeader sectionName={'SKILLS'}/>
            <div className={'skills-wrapper'}>
                <div className={'my-skills'}>
                    <h4>🌐 Frontend</h4>
                    <ul>
                        <li>React, Redux</li>
                        <li>Javascript, Typescript</li>
                        <li>Material-UI, CSS</li>
                    </ul>
                </div>

                <div className={'my-skills'}>
                    <h4>⚙️Backend</h4>
                    <ul>
                        <li>JAVA, Maven</li>
                        <li>Springboot</li>
                    </ul>
                </div>

                <div className={'my-skills'}>
                    <h4>🛠️ Devops/Processes</h4>
                    <ul>
                        <li>Git, Github, GHA</li>
                        <li>Aws - SQS, EC2, ECS</li>
                        <li>Agile Scrum, Jira</li>
                    </ul>
                </div>

                <div className={'my-skills'}>
                    <h4>🗄️Database</h4>
                    <ul>
                        <li>MongoDb</li>
                        <li>MySQL</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}